module.exports = __webpack_public_path__ + "media/styles/images/png/pen-gray-dark-fadb3306bd12e1b036b05a936501765f.png";